module.exports = __webpack_public_path__ + "static/img/woxing-going-out.1c03ebba.png";